import _AssignedReader from './model';

const AssignedReader = _AssignedReader;

export default AssignedReader;



// WEBPACK FOOTER //
// ./data/Reader/AssignedReader/index.js